<script setup lang="ts">
// Root shell — RouterView injects either AuthLayout or AdminLayout.
</script>

<template>
  <RouterView />
</template>
